export const text = {
  pageTitle: "FAQs",
  typeOfFaq: "Type of FAQ",
  question: "Question",
  answer: "Answer",
  addTitle: "Add FAQs",
  editTitle: "Edit FAQs",
  massage: "Are you sure?",
  text: "You want to delete this faq, you won't be able to revert this!",
  action: "Action",
  answerPlaceholder: "Enter Answer",
  questionPlaceholder: "Enter Question",
  addFaqs: "Add FAQs",
  faqsDetails: "FAQs Details",
  deleteDocumentText: "you want to delete this FAQs?",
  enterContactNo: "Enter Contact No",
  contactNo: "Contact No",
  address: "Address",
  enterAddress: "Enter Address",
  emailPlaceholder: "Enter Email Address",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms & Conditions",
  contactUs: "Contact Us",
  faq: "FAQ'S",
  title: "Title",
  enterTitle: "Enter Title",
  content: "Content",
  about: "About Us",
  privacy: "Privacy Policy",
  metaTitle: "Title",
  enterContent: "Enter Content",
  haveAQuestions: "Have a Question ?",
};
